import script from "./AdminPendingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPendingPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminPendingPage.vue?vue&type=style&index=0&id=ffa4a8ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffa4a8ce"]])

export default __exports__